import { useCreateCompetitionTeamMutation } from '../mutations';
import { CompetitionTeamForm } from './components/team-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Schema } from './components/team-form.schema';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { idParamSchema } from '~/schemas';
import { useSearchParams, useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export const Page = withPrivateRoute(() => {
  const { id } = useParams(idParamSchema.parse);

  const [searchParams] = useSearchParams();

  const divisionParam = searchParams.get('division');
  const initialDivision = divisionParam ? Number(divisionParam) : undefined;

  const mutation = useCreateCompetitionTeamMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(
      mutation.mutateAsync({
        division: payload.division,
        name: payload.name,
        club: payload.club?.[1] ?? null,
      }),
      {
        success: 'Laget har skapats',
        pending: 'Skapar laget...',
      }
    );
    navigate(-1);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa lag" />

      <PageLayout.Section>
        <CompetitionTeamForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="create"
          competitionId={id}
          defaultValues={{ division: initialDivision, club: null }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
